<template>
  <q-layout view="lHh Lpr lFf" class="l-print">
    <q-header
      v-if="
        route.name != 'Login' &&
        route.name != 'Outgoing Faktur' &&
        route.name != 'Internal Faktur' &&
        route.name != 'Mapping Print'
      "
      unelevated
      class="bg-white text-black"
    >
      <q-toolbar>
        <q-img
          :src="`./img/logo_head.png`"
          height="40px"
          width="115px"
          fit="contain"
        ></q-img>

        <q-space></q-space>
        <div class="row items-center q-gutter-x-sm">
          <div class="text-grey-6">v 2.21.1</div>
          <q-avatar>
            <img :src="'./img/avatar.png'" />
          </q-avatar>
          <q-btn-dropdown
            flat
            no-caps
            dropdown-icon="keyboard_arrow_down"
            dense
          >
            <template v-slot:label>
              <div class="text-left">
                <div class="text-bold">{{ route.meta.user?.name }}</div>
                <div class="l-text-thin text-grey-6" style="line-height: 14px">
                  {{ route.meta.user?.role }}
                </div>
              </div>
            </template>

            <q-card class="row no-wrap all-radius column" style="width: 250px">
              <q-card-section class="column items-center q-gutter-y-sm">
                <q-avatar size="72px">
                  <img :src="'./img/avatar.png'" />
                </q-avatar>
                <div class="text-center">
                  <div class="text-bold l-text-detail">
                    {{ route.meta.user?.name }}
                  </div>
                  <div
                    class="l-text-thin text-grey-6"
                    style="line-height: 14px"
                  >
                    {{ route.meta.user?.role }}
                  </div>
                </div>
              </q-card-section>

              <q-btn
                dense
                flat
                class="q-px-md q-py-sm"
                icon="lock_outline"
                label="Ubah Sandi"
                no-caps
                align="left"
                v-close-popup
                @click="showDialogPass"
              />
              <q-separator size="1px" color="grey-4"></q-separator>
              <q-btn
                dense
                flat
                class="q-px-md q-py-sm"
                icon="logout"
                label="Logout"
                color="negative"
                no-caps
                align="left"
                v-close-popup
                @click="logout"
              />
            </q-card>
          </q-btn-dropdown>
        </div>
      </q-toolbar>
      <q-separator />
    </q-header>

    <q-drawer
      v-if="
        route.name != 'Login' &&
        !isMobile &&
        is_drawer_shown &&
        route.name != 'Outgoing Faktur' &&
        route.name != 'Internal Faktur' &&
        route.name != 'Mapping Print'
      "
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      class="bg-white column"
      :mini="miniState"
      @mouseover="miniState = false"
      @mouseout="miniState = true"
    >
      <q-list>
        <!-- <q-item
          clickable
          class="inactive-menu"
          :active-class="miniState ? 'text-brand' : 'text-brand active-menu'"
          to="/"
        >
          <q-item-section avatar>
            <q-icon name="dashboard" />
          </q-item-section>

          <q-item-section>Dashboard</q-item-section>
        </q-item> -->

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'Main Dashboard' ||
            route.name == 'Top Product' ||
            route.name == 'Critical SKU' ||
            route.name == 'Analisa Tier'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'Main Dashboard',
              'Top Product',
              'Critical SKU',
              'Analisa Tier',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="dashboard" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Dashboard</q-item-label>
            </q-item-section>
          </template>

          <q-item
            active-class="active-menu"
            :active="
              route.name == 'Main Dashboard' || route.name == 'Top Product'
            "
            to="/"
          >
            <q-item-section avatar> </q-item-section>

            <q-item-section
              :class="
                route.name == 'Main Dashboard' || route.name == 'Top Product'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Main Dashboard</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Critical SKU'"
            to="/critical-sku"
          >
            <q-item-section avatar> </q-item-section>

            <q-item-section
              :class="
                route.name == 'Critical SKU' ? 'text-brand' : 'text-black'
              "
              >SKU Kritis</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Analisa Tier'"
            to="/analisa-tier"
          >
            <q-item-section avatar> </q-item-section>

            <q-item-section
              :class="
                route.name == 'Analisa Tier' ? 'text-brand' : 'text-black'
              "
              >Performa Produk</q-item-section
            >
          </q-item>
        </q-expansion-item>

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'Report List' ||
            route.name == 'List' ||
            route.name == 'Outbound' ||
            route.name == 'Manual via Excell' ||
            route.name == 'Barang Retur' ||
            route.name == 'another' ||
            route.name == 'Loan List' ||
            route.name == 'Loan Detail' ||
            route.name == 'Outgoing List' ||
            route.name == 'Outgoing Form' ||
            route.name == 'Outgoing Detail' ||
            route.name == 'Internal List' ||
            route.name == 'Internal Form'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'List',
              'Outbound',
              'Manual via Excell',
              'Barang Retur',
              'another',
              'Report List',
              'Loan List',
              'Loan Detail',
              'Outgoing List',
              'Outgoing Form',
              'Outgoing Detail',
              'Internal List',
              'Internal Form',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="barcode_reader" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Outbound</q-item-label>
            </q-item-section>
          </template>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Report List'"
            to="/report"
          >
            <q-item-section avatar> </q-item-section>

            <q-item-section
              :class="route.name == 'Report List' ? 'text-brand' : 'text-black'"
              >Laporan Cetak Resi</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'List'"
            to="/scan"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="route.name == 'List' ? 'text-brand' : 'text-black'"
              >List Scan</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Loan List' || route.name == 'Loan Detail'"
            to="/loan"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Loan List' || route.name == 'Loan Detail'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Shoes On Loan</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="
              route.name == 'Outgoing List' ||
              route.name == 'Outgoing Detail' ||
              route.name == 'Outgoing Form'
            "
            to="/outgoing"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Outgoing List' ||
                route.name == 'Outgoing Detail' ||
                route.name == 'Outgoing Form'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Faktur Barang Keluar</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="
              route.name == 'Internal List' || route.name == 'Internal Form'
            "
            to="/internal"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Internal List' || route.name == 'Internal Form'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Penjualan Internal</q-item-section
            >
          </q-item>
        </q-expansion-item>

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'Inbound List' ||
            route.name == 'Inbound Detail' ||
            route.name == 'Mapping List' ||
            route.name == 'Mapping Inbound' ||
            route.name == 'Mapping Detail'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'Inbound List',
              'Inbound Detail',
              'Mapping Inbound',
              'Mapping List',
              'Mapping Detail',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="local_shipping" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Inbound</q-item-label>
            </q-item-section>
          </template>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Inbound List'"
            to="/inbound"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Inbound List' ? 'text-brand' : 'text-black'
              "
              >Daftar Inbound</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Mapping List'"
            to="/inbound/list-mapping"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Mapping List' ? 'text-brand' : 'text-black'
              "
              >Pemetaan Inbound</q-item-section
            >
          </q-item>
        </q-expansion-item>

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'List Retur' ||
            route.name == 'Form Retur' ||
            route.name == 'Barang Retur Masuk' ||
            route.name == 'Barang Retur Keluar' ||
            route.name == 'Proses Barang Retur' ||
            route.name == 'Atur Pengiriman Barang Retur'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'List Retur',
              'Form Retur',
              'Barang Retur Masuk',
              'Barang Retur Keluar',
              'Proses Barang Retur',
              'Atur Pengiriman Barang Retur',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="o_assignment_return" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Man. Retur</q-item-label>
            </q-item-section>
          </template>
          <q-item
            active-class="active-menu"
            :active="route.name == 'List Retur'"
            to="/retur"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="route.name == 'List Retur' ? 'text-brand' : 'text-black'"
              >List</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Form Retur'"
            to="/retur/form"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="route.name == 'Form Retur' ? 'text-brand' : 'text-black'"
              >Tambah Retur</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Barang Retur Masuk'"
            to="/retur/in"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Barang Retur Masuk' ? 'text-brand' : 'text-black'
              "
              >Scan Retur Masuk</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Barang Retur Keluar'"
            to="/retur/out"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Barang Retur Keluar'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Scan Retur Keluar</q-item-section
            >
          </q-item>
          <q-item class="text-black" clickable @click="showDialogExportRetur">
            <q-item-section avatar></q-item-section>
            <q-item-section> Export Scan Retur </q-item-section>
          </q-item>
        </q-expansion-item>

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'List Stok' ||
            route.name == 'Riwayat Stok' ||
            route.name == 'Pengingat Stok' ||
            route.name == 'Stok Siap Order' ||
            route.name == 'Riwayat Penyesuaian Stok' ||
            route.name == 'Analisa Stok' ||
            route.name == 'Form Penyesuaian'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'List Stok',
              'Riwayat Stok',
              'Pengingat Stok',
              'Stok Siap Order',
              'Riwayat Penyesuaian Stok',
              'Analisa Stok',
              'Form Penyesuaian',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="inventory" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Stok</q-item-label>
            </q-item-section>
          </template>
          <q-item
            active-class="active-menu"
            :active="route.name == 'List Stok'"
            to="/stock"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="route.name == 'List Stok' ? 'text-brand' : 'text-black'"
              >Stok Produk Gudang</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Riwayat Penyesuaian Stok'"
            to="/stock/adjustment"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Riwayat Penyesuaian Stok'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Riwayat Penyesuaian</q-item-section
            >
          </q-item>
          <q-item
            active-class="active-menu"
            :active="route.name == 'Pengingat Stok'"
            to="/stock/reminder"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Pengingat Stok' ? 'text-brand' : 'text-black'
              "
              >Stok Artikel Menipis</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Stok Siap Order'"
            to="/stock/siap-order"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Stok Siap Order' ? 'text-brand' : 'text-black'
              "
              >Stok SKU Menipis</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Analisa Stok'"
            to="/analisa"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Analisa Stok' ? 'text-brand' : 'text-black'
              "
              >Analisa Stok</q-item-section
            >
          </q-item>

          <!-- <q-item
            active-class="active-menu"
            :active="route.name == 'Sync Stok E-Commerce'"
            to="/stock/ecommerce"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Sync Stok E-Commerce'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Sync Stok E-Commerce</q-item-section
            >
          </q-item> -->
        </q-expansion-item>

        <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'List Inventory' ||
            route.name == 'Download Inventory' ||
            route.name == 'Connect Inventory' ||
            route.name == 'Sync Stok E-Commerce' ||
            route.name == 'List Sync Stock' ||
            route.name == 'Form Sync Stock' ||
            route.name == 'Updated Product' ||
            route.name == 'List Update Price' ||
            route.name == 'Form Update Price' ||
            route.name == 'Detail Update Price' ||
            route.name == 'List Discount' ||
            route.name == 'Detail Discount'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'List Inventory',
              'Download Inventory',
              'Connect Inventory',
              'Sync Stok E-Commerce',
              'List Sync Stock',
              'Form Sync Stock',
              'Updated Product',
              'List Update Price',
              'Form Update Price',
              'Detail Update Price',
              'List Discount',
              'Detail Discount',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="local_mall" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Master Produk</q-item-label>
            </q-item-section>
          </template>

          <q-item
            active-class="active-menu"
            :active="route.name == 'List Inventory'"
            to="/inventory"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'List Inventory' ? 'text-brand' : 'text-black'
              "
              >Download & Mapping Produk</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'List Sync Stock'"
            to="/inventory/list-sync-stock"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'List Sync Stock' ? 'text-brand' : 'text-black'
              "
              >Sync Stok</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Updated Product'"
            to="/inventory/updated-product"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Updated Product' ? 'text-brand' : 'text-black'
              "
              >Perubahan Produk E-Commerce</q-item-section
            >
          </q-item>

          <q-item
            v-can="['ADMINISTRATOR']"
            active-class="active-menu"
            :active="
              route.name == 'List Update Price' ||
              route.name == 'Form Update Price' ||
              route.name == 'Detail Update Price'
            "
            to="/update-price"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'List Update Price' ||
                route.name == 'Form Update Price' ||
                route.name == 'Detail Update Price'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Update Harga Massal</q-item-section
            >
          </q-item>

          <q-item
            v-can="['ADMINISTRATOR']"
            active-class="active-menu"
            :active="route.name == 'Live Prices'"
            to="/update-price/live"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="route.name == 'Live Prices' ? 'text-brand' : 'text-black'"
              >Cek Harga Live</q-item-section
            >
          </q-item>

          <q-item
            v-can="['ADMINISTRATOR']"
            active-class="active-menu"
            :active="
              route.name == 'List Discount' || route.name == 'Detail Discount'
            "
            to="/discount"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'List Discount' || route.name == 'Detail Discount'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Daftar Diskon</q-item-section
            >
          </q-item>
        </q-expansion-item>

        <!-- <q-item
          clickable
          class="inactive-menu"
          :active-class="miniState ? 'text-brand' : 'text-brand active-menu'"
          to="/inventory"
        >
          <q-item-section avatar>
            <q-icon name="local_mall" />
          </q-item-section>

          <q-item-section>Master Produk</q-item-section>
        </q-item> -->

        <!-- <q-expansion-item
          class="cursor-pointer"
          :class="
            route.name == 'Marketplace Product' ||
            route.name == 'Affiliate Product' ||
            route.name == 'Affiliate Form' ||
            route.name == 'Marketplace Form'
              ? `text-brand`
              : ''
          "
          group="menuGroup"
          :model-value="
            is_expanded([
              'Marketplace Product',
              'Affiliate Product',
              'Affiliate Form',
              'Marketplace Form',
            ])
          "
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="travel_explore" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Marketplace Mapping</q-item-label>
            </q-item-section>
          </template>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Marketplace Product'"
            to="/marketplace"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Marketplace Product'
                  ? 'text-brand'
                  : 'text-black'
              "
              >Main Product</q-item-section
            >
          </q-item>

          <q-item
            active-class="active-menu"
            :active="route.name == 'Affiliate Product'"
            to="/marketplace/list-affiliate"
          >
            <q-item-section avatar></q-item-section>
            <q-item-section
              :class="
                route.name == 'Affiliate Product' ? 'text-brand' : 'text-black'
              "
              >Affiliate Product</q-item-section
            >
          </q-item>
        </q-expansion-item> -->

        <!-- <q-item
          clickable
          class="inactive-menu"
          :active-class="miniState ? 'text-brand' : 'text-brand active-menu'"
          to="/stock-sync"
        >
          <q-item-section avatar
            ><q-icon name="sym_o_cloud_sync"
          /></q-item-section>

          <q-item-section>Sync Stock to E-Commerce</q-item-section>
        </q-item> -->

        <q-item
          clickable
          class="inactive-menu"
          :active-class="miniState ? 'text-brand' : 'text-brand active-menu'"
          to="/settings"
          :active="
            route.name == 'Integration' ||
            route.name == 'List Sinkronisasi' ||
            route.name == 'Detail Sinkronisasi' ||
            route.name == 'Setting List' ||
            route.name == 'Manage Shipment' ||
            route.name == 'Color List'
          "
        >
          <q-item-section avatar><q-icon name="settings" /></q-item-section>
          <q-item-section>Pengaturan</q-item-section>
        </q-item>

        <q-item clickable active-class="text-brand" @click="showDialogExport">
          <q-item-section avatar><q-icon name="download" /></q-item-section>

          <q-item-section>Export Code-Color</q-item-section>
        </q-item>
      </q-list>
      <q-space></q-space>
    </q-drawer>

    <q-page-container class="my-font printCond">
      <div class="l-page-loading-wrap">
        <router-view class="my-font l-mobile-container l-print" />
        <!-- overlay loading khusus area halaman; sidebar tetap bisa diklik -->
        <q-inner-loading :showing="pageLoading" class="l-page-loading">
          <q-spinner-dots size="50px" color="primary" />
        </q-inner-loading>
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from "vue";
import useBasic, { pageLoading } from "./composables/useBasic";
import dialogExportExcell from "./components/dialogExportExcell.vue";
import dialogExportExcellRetur from "./components/dialogExportExcellRetur.vue";
import dialogExcellColumn from "./components/dialogExcellColumn.vue";
import dialogPassword from "./components/dialogPassword.vue";
export default {
  name: "LayoutDefault",

  setup() {
    const { route, router, $q, reactive, onMounted, isMobile, watch } =
      useBasic();

    onMounted(async () => {
      // showDialogColumn();
    });

    let showDialogPass = () => {
      $q.dialog({
        component: dialogPassword,
      });
    };

    let routes = ref([
      { label: "", desc: "", link: "", is_expanded: false, icon: "" },
    ]);

    let data = reactive({
      router_to: "",
    });

    let logout = () => {
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      router.push("/login");
    };

    let showDialogExport = () => {
      $q.dialog({
        component: dialogExportExcell,
      });
    };

    let showDialogExportRetur = () => {
      $q.dialog({
        component: dialogExportExcellRetur,
        props: {
          is_retur: true,
        },
      });
    };

    let showDialogColumn = () => {
      $q.dialog({
        component: dialogExcellColumn,
      });
    };

    let miniState = ref(true);

    let drawerClick = (e) => {
      if (miniState.value) {
        miniState.value = false;

        e.stopPropagation();
      }
    };

    let is_expanded = (menus) => {
      if (menus.includes(route.name)) return true;
      return false;
    };

    let is_drawer_shown = ref(true);

    return {
      leftDrawerOpen: ref(false),
      route,
      router,
      data,
      logout,
      showDialogExport,
      drawerClick,
      miniState,
      isMobile,
      showDialogPass,
      is_expanded,
      is_drawer_shown,
      showDialogExportRetur,
      pageLoading,
    };
  },
};
</script>
<style lang="scss">
@import "@/styles/quasar.scss";
// pembungkus router-view supaya q-inner-loading menutupi area halaman saja
.l-page-loading-wrap {
  position: relative;
  min-height: 100%;
}
.stickyTable {
  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: $grey-2;
    color: #000000;
    font-weight: bold;
  }
  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    top: 48px;
  }
}

.stickyHead_LastCol {
  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: $grey-2;
    color: #000000;
    font-weight: bold;
  }
  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    top: 48px;
  }

  /* Sticky for the last column */
  tbody td:last-child,
  thead th:last-child {
    position: sticky;
    right: 0;
    background-color: $grey-1;
    z-index: 2; /* Higher z-index to ensure it's above other content */
  }
}

.l-container {
  height: 100vh;
}

.q-drawer {
  margin-top: 50px !important;
}

.q-header {
  left: 0 !important;
}

.l-mobile-container {
  max-width: 1440px;
  min-width: 300px;

  margin: 0 auto;
}

.l-footer-container {
  max-width: 1400px !important;
  min-width: 300px !important;

  margin: 0 auto;
}

.l-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.l-grow {
  flex-grow: 99 !important;
}

@font-face {
  font-family: barcode;
  src: url(./styles/fonts/barcode.TTF);
}

@font-face {
  font-family: code128;
  src: url(./styles/fonts/code128.ttf);
}

@font-face {
  font-family: customfont;
  src: url(./styles/fonts/Sora-Regular.ttf);
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Sora-Bold.ttf");
  font-weight: 700;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Sora-SemiBold.ttf");
  font-weight: 500;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Sora-Bold.ttf");
  font-weight: 300;
}

.my-font {
  font-family: "customfont";
}

.barcode-font {
  font-family: "barcode" !important;
}

.barcode-128 {
  font-family: "code128" !important;
}

.f10 {
  font-size: 10pt;
}
.f12 {
  font-size: 12pt;
}
.f14 {
  font-size: 14pt;
}
.f16 {
  font-size: 16pt;
}
.f18 {
  font-size: 18pt;
}
.f20 {
  font-size: 20pt;
}

.text-bolder {
  font-weight: 900;
}

.bg-brand {
  background: #3d3099 !important;
}

.text-brand {
  color: #3d3099 !important;
}

.l-text-header {
  font-size: 40px !important;
  line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 36px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title {
  font-size: 32px !important;
  line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 26px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 20px !important;
  }
}

.l-text-subtitle {
  font-size: 20px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 16px !important;
  }
}

.l-text-detail {
  font-size: 18px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 13px !important;
  }
}

.l-text-description {
  font-size: 14px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 11px !important;
  }
}

.border-card {
  border-radius: 4px !important;
  border: 1px solid #bbbbbb;
}

.long-text-dots {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.kiri-radius {
  border: 1px solid #bbbbbb;
  border-radius: 4px 0 0 4px !important;
}

.kanan-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 4px 4px 0 !important;
}
.atas-radius {
  border: 1px solid #bbbbbb;
  border-radius: 4px 4px 0 0 !important;
}
.bawah-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 0 4px 4px !important;
}

.all-radius {
  border: 1px solid #bbbbbb;
  border-radius: 4px 4px 4px 4px !important;
}

.active-menu {
  padding-left: 14px !important;
  border-left: 2px solid #3d3099 !important;
}

.inactive-menu {
  border-left: none;
}

.l-wrap-cell {
  word-wrap: break-word !important; /* Ensures that words break and wrap to the next line */
  white-space: normal !important; /* Overrides any contrary settings that prevent wrapping */
  word-break: break-all;
}

.printPaperA5 {
  width: 148mm;
}

.printPaperA4 {
  width: 210mm;
}

.printCond {
  background-color: $grey-3 !important; /* Remove any background */
}

@media print {
  .printCond {
    background-color: white !important; /* Remove any background */
    margin: 0;
    padding: 0;
  }
  .l-print {
    min-height: none !important;
  }
  .q-layout {
    min-height: 0 !important;
  }
  .q-page {
    min-height: 0 !important;
  }
}
</style>
